import Navigation from "./modules/navigation";
import SectionNavigation from "./modules/section-navigation";
import HomepageHero from "./modules/homepage-hero";
import GatedPopUp from "./modules/gated-pop-up";
import HomepageLatestCarousel from "./modules/homepage-latest-carousel";
import ShareLinks from "./modules/share-links";
import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";

//Alpine Init
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  Navigation();
  SectionNavigation();
  HomepageHero();
  HomepageLatestCarousel();
  ShareLinks();
  GatedPopUp();
});

// set up the homepage slideshow
// to start on a random slide:
let initialSlideIndex = 0;
const homepageCarousel = document.getElementById('homepageCarousel');
if(homepageCarousel) {
  const numberOfSlides = homepageCarousel.dataset.numberOfSlides;
  initialSlideIndex = Math.floor(Math.random() * numberOfSlides)
}


$('.carousel-main').flickity({
  cellSelector: '.slide-cell',
  accessibility: true,
  prevNextButtons: true,
  pageDots: false,
  setGallerySize: false,
  wrapAround: true,
  imagesLoaded: true,
  initialIndex: initialSlideIndex,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  }
});

var $nav = $('.carousel-nav').flickity({
  asNavFor: '.carousel-main',
  pageDots: false,
  prevNextButtons: false,
  wrapAround: true,
  contain: true
});



window.onscroll = function() {scrollFunction()};

function scrollFunction() {
    if (!sessionStorage.getItem("subBarClosed")) {
      if (document.body.scrollTop > 250 || document.documentElement.scrollTop > 250) {
        // document.getElementById("subscribe-bar").style.bottom = "0";
        $('#subscribe-bar').fadeIn('fast');
      }
      else {
        // document.getElementById("subscribe-bar").style.bottom = "-75px";
        $('#subscribe-bar').fadeOut('fast');
      }
    }
    else {
      // document.getElementById("subscribe-bar").style.bottom = "-75px";
      $('#subscribe-bar').fadeOut('fast');
    }
}

var $closeSubBar = $('.close-subscribe-bar');
$closeSubBar.on('click', function() {
  // document.getElementById("subscribe-bar").style.bottom = "-75px";
  $('#subscribe-bar').fadeOut('fast');
  sessionStorage.setItem('subBarClosed', 'true');
})

// test if user is using IE11
function is_IE() {
  return (window.navigator.userAgent.match(/MSIE|Trident/) !== null);
}

// Algolia Search
if ($('#searchbox').length > 0) {
  var queryParams, sortBy = '';
  if (typeof params !== 'undefined') {
    queryParams = JSON.parse(params);
  }
  if (typeof orderBy !== 'undefined') {
    sortBy = JSON.parse(orderBy);
  }

  // sortByItems should not include 'Relevant' unless there's a q query string (which comes from the site search field)
  var urlParams = new URLSearchParams(window.location.search);
  var searchFilterParam = urlParams.get('q');
  var sortByOptions = [
    { label: 'Recent', value: algoliaIndexName + '_postDate_desc' },
    { label: 'Popular', value: algoliaIndexName + '_totalViews_desc' },
  ];
  if(searchFilterParam || window.location.pathname == '/search') {
    sortByOptions = [
      { label: 'Relevant', value: algoliaIndexName },
      { label: 'Recent', value: algoliaIndexName + '_postDate_desc' },
      { label: 'Popular', value: algoliaIndexName + '_totalViews_desc' },
    ];
  }

  const search = instantsearch({
    indexName: algoliaIndexName,
    searchClient: algoliasearch('YFVVW2R7HI', '20f7a3f8c3ffd46090d79eb033ef1815'),
    searchFunction(helper) {
      const page = helper.getPage(); // Retrieve the current page

      // hide featured entries on Algolia pagination inner pages
      if (page > 0) {
        [].forEach.call(document.querySelectorAll('article.featured-article'), function (el) {
          el.style.display = 'none';
        });
      }
      else{
        [].forEach.call(document.querySelectorAll('article.featured-article'), function (el) {
          el.style.display = 'block';
        });
      }

      helper.search();
    },
    initialUiState: {
      [algoliaIndexName]: {
        query: searchFilterParam,
      },
    },
  });

  var segment = window.location.pathname.split("/").pop();
  if (segment != "archive") {
    search.addWidgets([
      instantsearch.widgets.refinementList({
        container: '#contentType',
        attribute: 'contentType',
        showMore: true,
        sortBy: ['name:asc'],
        templates: {
          item(item) {
            const { cssClasses, label, count, isRefined, value } = item;

            return `
            <label class="${ cssClasses.label }"> <input type="checkbox" class="${ cssClasses.checkbox }" value="${value}" ${isRefined ? 'checked' : ''}> <span class="${ cssClasses.labelText }">${ label }</span> <span class="${ cssClasses.count }">(${ count })</span> </label>
            `;
          },
        },
      })
    ]);
  }

  // custom pagination markup to match the pagination markup/styles
  // on the publications page:
  const renderPagination = (renderOptions, isFirstRender) => {
    const {
      pages,
      currentRefinement,
      nbPages,
      isFirstPage,
      isLastPage,
      refine,
      createURL,
    } = renderOptions;

    const container = document.querySelector('#pagination');

    container.innerHTML = `
      <ul class="pagination">
        ${
          !isFirstPage
            ? `
              <li class="previous">
                <a
                  href="${createURL(currentRefinement - 1)}"
                  data-value="${currentRefinement - 1}"
                >
                  Previous
                </a>
              </li>
              <li>
                <a
                  href="${createURL(0)}"
                  data-value="${0}"
                >
                  First
                </a>
              </li>
              `
            : ''
        }
        ${pages
          .map(
            page => `
                <a class="${currentRefinement === page ? 'current current-instant-search-widget' : ''}"
                  href="${createURL(page)}"
                  data-value="${page}"
                  style="pointer-events: ${currentRefinement === page ? 'none' : ''}"
                >
                  <span>${page + 1}</span>
                </a>
            `
          )
          .join('')}
          ${
            !isLastPage
              ? `
                <li>
                  <a
                    href="${createURL(nbPages - 1)}"
                    data-value="${nbPages - 1}"
                  >
                    Last
                  </a>
                </li>
                <li class="next">
                  <a
                    href="${createURL(currentRefinement + 1)}"
                    data-value="${currentRefinement + 1}"
                  >
                    Next
                  </a>
                </li>
                `
              : ''
          }
      </ul>
    `;

    [...container.querySelectorAll('a')].forEach(element => {
      element.addEventListener('click', event => {
        event.preventDefault();
        refine(event.currentTarget.dataset.value);
      });
    });
  };

  // Create the custom widget
  const customPagination = instantsearch.connectors.connectPagination(
    renderPagination
  );

  // Instantiate the custom widget
  search.addWidgets([
    customPagination({
      container: document.querySelector('#pagination'),
    })
  ]);

  var urlParams = new URLSearchParams(window.location.search);
  var titleParam = urlParams.get('title');
  var showMoreTopicsText = 'Topics';
  if(titleParam && titleParam == 'People'){
    showMoreTopicsText = 'Areas of Expertise';
  }

  search.addWidgets([
    instantsearch.widgets.searchBox({
      container: '#searchbox',
      autofocus: true,
    }),
    instantsearch.widgets.clearRefinements({
      container: '#clear-refinements',
    }),
    instantsearch.widgets.refinementList({
      container: '#relatedProgramArea',
      attribute: 'relatedProgramArea',
      showMore: true,
      sortBy: ['name:asc'],
      templates: {
        item(item) {
          const { cssClasses, label, count, isRefined, value } = item;

          return `
          <label class="${ cssClasses.label }"> <input type="checkbox" class="${ cssClasses.checkbox }" value="${value}" ${isRefined ? 'checked' : ''}> <span class="${ cssClasses.labelText }">${ label }</span> <span class="${ cssClasses.count }">(${ count })</span> </label>
          `;
        },
      },
    }),
    instantsearch.widgets.refinementList({
      container: '#audienceRole',
      attribute: 'audienceRole',
      showMore: true,
      sortBy: ['name:asc'],
      templates: {
        item(item) {
          const { cssClasses, label, count, isRefined, value } = item;

          return `
          <label class="${ cssClasses.label }"> <input type="checkbox" class="${ cssClasses.checkbox }" value="${value}" ${isRefined ? 'checked' : ''}> <span class="${ cssClasses.labelText }">${ label }</span> <span class="${ cssClasses.count }">(${ count })</span> </label>
          `;
        },
      },
    }),
    instantsearch.widgets.refinementList({
      container: '#reportSeries',
      attribute: 'reportSeries',
      showMore: true,
      showMoreLimit: 40,
      sortBy: ['name:asc'],
      templates: {
        item(item) {
          const { cssClasses, label, count, isRefined, value } = item;

          return `
          <label class="${ cssClasses.label }"> <input type="checkbox" class="${ cssClasses.checkbox }" value="${value}" ${isRefined ? 'checked' : ''}> <span class="${ cssClasses.labelText }">${ label }</span> <span class="${ cssClasses.count }">(${ count })</span> </label>
          `;
        },
        showMoreText: `
        {{#isShowingMore}}
          See Fewer Series
        {{/isShowingMore}}
        {{^isShowingMore}}
          See More Series
        {{/isShowingMore}}
      `
      }
    }),
    instantsearch.widgets.refinementList({
      container: '#topics',
      attribute: 'topics',
      showMore: true,
      showMoreLimit: 45,
      sortBy: ['name:asc'],
      templates: {
        item(item) {
          const { cssClasses, label, count, isRefined, value } = item;

          return `
          <label class="${ cssClasses.label }"> <input type="checkbox" class="${ cssClasses.checkbox }" value="${value}" ${isRefined ? 'checked' : ''}> <span class="${ cssClasses.labelText }">${ label }</span> <span class="${ cssClasses.count }">(${ count })</span> </label>
          `;
        },
        showMoreText: `
          {{#isShowingMore}}
            See Fewer ${showMoreTopicsText}
          {{/isShowingMore}}
          {{^isShowingMore}}
            See More ${showMoreTopicsText}
          {{/isShowingMore}}
        `
      },
    }),
    instantsearch.widgets.sortBy({
      container: '#sort-by',
      items: sortByOptions,
      cssClasses: {
        root: 'styled',
      },
    }),
    instantsearch.widgets.hits({
      container: '#hits',
      templates: {
        empty: 'Sorry no results found.',
        item: function(data) {
            // check if live and enabled
            if (data.status !== 'live' || data.enabled != '1') {
              return;
            }
            let now = new Date();
            now = now.toISOString();
            // check if content expired
            if (data.expiryDate !== null) {
              if(data.expiryDate < now){
                return;
              }
            }
            // check if not published yet
            if (data.postDate !== null) {
              if(data.postDate > now){
                return;
              }
            }
            let articleClass = '';
            if (data.section == 'report' || data.section == 'dataBook' || data.section == 'onlineReport') {
              articleClass = ' class="report"';
            }
            let contentType = null;
            let noImageBadge = '';

            if (data.contentType && data.contentType.length) {
              // webinars often have multiple content types
              // (for example, they're also blog posts),
              // so this ensures that Webinar shows on the label
              if (data.contentType.indexOf('Webinar') != -1) {
                contentType = 'Webinar';
              } else {
                contentType = data.contentType[0];
              }
            }

            let map = {
              'Blog Post': 'browser',
              'Interview': 'profile',
              'Job': 'profile',
              'People': 'user',
              'Video': 'youtube',
              'Webinar': 'youtube',
              'Presentation': 'file-text2',
              'Speech': 'user',
              'Report': 'book',
              'Online Report': 'book',
              'Data Book': 'book',
              'Brief': 'newspaper',
              'Infographic': 'pie-chart',
              'Policy Report': 'text-document',
              'Practice Guide': 'file-text2',
              'Training Curriculum': 'training',
              'Training Material': 'training',
            };
            if (contentType && data.imageUrl == null) {
              if (map[contentType]) {
                noImageBadge = `<p class="badge"><span aria-hidden="true" class="icon icon-${map[contentType]}"></span> ${contentType}</p>`;
              }
              else{
                noImageBadge = `<p class="badge"><span aria-hidden="true" class="icon icon-newspaper"></span> ${contentType}</p>`;
              }
            }

            let title = `<h3 class="article-title no-subhead"><a href="${data.url}">${data.title}</a></h3>`;
            if (data.subtitle) {
              title = `<h3 class="article-title"><a href="${data.url}">${data.title}</a></h3>`;
            }
            let subtitle = '';
            if (data.subtitle) {
              subtitle = `<p class="meta subhead">${data.subtitle.replace('®', '<sup>®</sup>')}</p>`;
            }
            let image = '<div class="col-3of3">';
            if (data.imageUrl) {
              let classes = '';
              let classes1 = '';
              let classes2 = '';
              if (data.section == 'report' || data.section == 'people' || data.section == 'onlineReport') {
                classes1 = 'col-1of3';
                classes2 = 'col-2of3';
              }
              else{
                classes1 = 'col-1of2';
                classes2 = 'col-1of2';
              }
              let badge = '';
              if (contentType) {
                if (map[contentType]) {
                  badge = `<h6 class="badge-img"><span aria-hidden="true" class="icon icon-${map[contentType]}"></span> ${contentType}</h6>`;
                }
                else{
                  badge = `<h6 class="badge-img"><span aria-hidden="true" class="icon icon-newspaper"></span> ${contentType}</h6>`;
                }
              }

              var imageAltText = data.title;
              if(data.hasOwnProperty('imageAltText')){
                imageAltText = data.imageAltText;
              }

              image = `<div class="${classes1} with-badge">
                      <a href="${data.url}">
                          ${badge}
                          <img src="${data.imageUrl}" alt="${imageAltText}"/>
                      </a>
                  </div>
                  <div class="${classes2}">
                  `;

            }
            let description = '';
            if (data.description) {
              description = `${data.description}`;
            }

            let postDate = '';
            if (data.postDate && data.section != 'people') {
              let date = new Date(data.postDate);
              var options;

              // the timeZone option doesn't work with IE11
              // and was causing search results to break completely in IE11
              if(is_IE()) {
                options = { year: 'numeric', month: 'long', day: 'numeric' };
              } else {
                // timezone needs to match the timezone set in General Settings in the CMS
                options = { timeZone: "America/Los_Angeles", year: 'numeric', month: 'long', day: 'numeric' };
              }
              postDate = date.toLocaleDateString('en-US', options);
            }

            var jobTitle = '';
            var readMoreText = 'Read More';
            var areasOfExpertise = '';
            if(data.section == 'people'){
              readMoreText = 'View Profile';

              jobTitle = `<h3>${data.jobTitle}</h3>`;

              if(data.topics.length) {
                var topicLinks = '';

                data.topics.forEach(function(topic, index){
                  var comma = '';
                  if(index + 1 < data.topics.length) {
                    comma = '<span class="comma">, </span>';
                  }
                  topicLinks += `<span class="display--inline-block"><a href="/topics/${data.topicSlugs[index]}">${topic}${comma}</a></span>`
                })
                areasOfExpertise = `<p class="meta">Areas of Expertise: ` + topicLinks + `</p>`
              }
            }

            return `
                <article ${articleClass}>
                  ${noImageBadge}

                  ${title}

                  ${subtitle}

                  ${image}

                  ${description}

                  ${jobTitle}

                  ${areasOfExpertise}

                  <p class="meta archive-date">${postDate}</p>
                  <p class="more"><a href="${data.url}">${readMoreText}</a></p>

                  </div>
              </article>
            `;
          },
      },
    }),
  ]);

  search.start();

  if (queryParams && queryParams.length){
    var filterString = '';
    for (var i = 0; i < queryParams.length; i++) {
      var param = queryParams[i];
      var arr = param.split(':');
      var facet = arr[0];
      var value = arr[1];
      // relatedInitiatives are only added as single facets
      // via links on Initiative pages and
      // this code ensures that the facet values
      // aren't split by commas, which many of the
      // Initiative titles contain
      if (facet == 'relatedInitiatives') {
        var arr2 = [value];
      } else {
        var arr2 = value.split(',');
      }

      if(arr2.length > 1){
        var temp = '';
        for (var j = 0; j < arr2.length; j++) {
          temp += facet + ':"' + arr2[j] + '"';
          if (arr2[j+1]) {
            temp += ' OR '
          }
        }
        temp = '(' + temp + ')';
        filterString += temp;

        if (queryParams[i+1]) {
          filterString += ' AND ';
        }
      }
      else{
        filterString += facet + ':"' + value + '"';
        if (queryParams[i+1]) {
          filterString += ' AND ';
        }
      }

    }
    search.helper.setQueryParameter('filters', filterString);

  }

  search.helper.setIndex(algoliaIndexName);

  if (sortBy && sortBy.length) {
    if (sortBy == 'popularity') {
      search.helper.setIndex(algoliaIndexName + '_totalViews_desc');
    }
    else if (sortBy == 'postDate desc') {
      search.helper.setIndex(algoliaIndexName + '_postDate_desc');
    }
    else {
      search.helper.setIndex(algoliaIndexName);
    }
  }

  search.helper.search();

  // Hides the refinement list heading when no refinement options exist as user searches
  search.on('render', () => {
    const refinementFilterLists = document.querySelectorAll('.ais-RefinementList');
    refinementFilterLists.forEach( refinement => {
      const refinementContainer = refinement.parentElement;
      const refinementHeading = refinementContainer.previousElementSibling;
      if(refinementHeading && refinementHeading.nodeName == 'H4') {
        if (refinement.classList.contains('ais-RefinementList--noRefinement')) {
          refinementHeading.classList.add('hidden');
        } else {
          refinementHeading.classList.remove('hidden');
        }
      }
    })
  });
}

const roleSelects = document.querySelectorAll('select[name="group[5241]"]');
if(roleSelects) {
  roleSelects.forEach( roleSelect => {
    roleSelect.addEventListener("change", updateSelected);
  })
}

function updateSelected() {
  const prevSelectedOption = this.querySelector('option[selected="selected"]');
  if(prevSelectedOption){
    prevSelectedOption.removeAttribute('selected');
  }
  const currentSelectedOption = this.querySelector('option[value="' + this.value +'"]')
  currentSelectedOption.setAttribute('selected', 'selected');
}

const formSubmitBtns = document.querySelectorAll('button[name="form_page_submit"]');
if(formSubmitBtns) {
  formSubmitBtns.forEach( btn => {
    btn.addEventListener("click", disableBtn);
  })
}

function disableBtn() {
  this.classList.add('disabled');
  // Add 3 second undo for when user hits HTML validation (like invalid email)
  setTimeout(() => {
    this.classList.remove('disabled');
  }, 3000);
}

// the code below selects a dynamic recipient
// to receive contact form submissions
const adminRecipientFields = document.querySelectorAll('select[name="adminRecipient"]');

// hide the adminRecipient select and label
if(adminRecipientFields){
  adminRecipientFields.forEach( adminRecipientField => {
    const selectWrapper = adminRecipientField.parentElement;
    if(selectWrapper){
      selectWrapper.classList.add('hidden');
    }
  });
}

const messageRelatesToFields = document.querySelectorAll('select[name="messageRelatesTo"]')
if(messageRelatesToFields) {
  messageRelatesToFields.forEach( messageRelatesToField => {
    messageRelatesToField.addEventListener("change", addRecipient);
  })
}

// when the selected value of the messageRelatesTo field changes,
// update the selected value of the hidden adminRecipient select field
// based on which option was selected
function addRecipient(e) {
  if(adminRecipientFields) {
    adminRecipientFields.forEach( adminRecipientField => {
      const prevSelectedOption = adminRecipientField.querySelector('option[selected]');
      if(prevSelectedOption){
        prevSelectedOption.removeAttribute('selected');
      }
      if(e.target.value == 'Publication Orders' || e.target.value == 'Casey Resources' || e.target.value == 'General Feedback' || e.target.value == 'Grant Inquiries') {
        adminRecipientField.querySelector('option[value="0"]').setAttribute('selected', 'selected');
      } else if (e.target.value == 'Media Inquiries') {
        adminRecipientField.querySelector('option[value="1"]').setAttribute('selected', 'selected');
      } else {
        adminRecipientField.querySelector('option[value="2"]').setAttribute('selected', 'selected');
      }
    });

  }
}
